
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import {
    renderAutoCompleteSingleSelect,
    renderTextField,
    isInteger, 
} from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { getPatientBehaviorsReductionByPatientId } from './actions/soapActions';
// import _ from 'lodash';
import SmallLoader from '../../../../img/small-loader.gif';

const validate = (values) => {
    const errors = {};

    if (!values.behaviorsReductionArray || !values.behaviorsReductionArray.length) {
        errors.behaviorsReductionArray = { _error: 'At least one behavior data must be selected' };
    } else {
        const behaviorsReductionArrayErrors = [];        
        values.behaviorsReductionArray.forEach((behaviorsReductionObj, index) => {            
            const behaviorsReductionErrors = {};
            if (!behaviorsReductionObj.behaviorsReductionId) {
                behaviorsReductionErrors.behaviorsReductionId = 'Please select behavior';
            }            

            if (!behaviorsReductionObj.skillsAcquisitionTargetId) {
                behaviorsReductionErrors.skillsAcquisitionTargetId = 'Please select target';
            }
            if (!behaviorsReductionObj.data) {
                behaviorsReductionErrors.data = 'Please enter data';
            }
            // if (!behaviorsReductionObj.comments) {
            //     behaviorsReductionErrors.comments = 'Please enter comments';
            // }
            behaviorsReductionArrayErrors[index] = behaviorsReductionErrors;
            return behaviorsReductionArrayErrors;
        });
        if (behaviorsReductionArrayErrors.length) {
            errors.behaviorsReductionArray = behaviorsReductionArrayErrors;
        }
    }
    return errors;
}
class AddBehaviorsReductionModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId,
            patientEncounterId: props.patientEncounterId,
            sessionNoteId: props.sessionNoteId,
            ebsBehaviorsReductionId: props.ebsBehaviorsReductionId,
        };
        this.addRow = this.addRow.bind(this);
        this.removeRow = this.removeRow.bind(this);
    }

    componentWillMount() {
        this.props.getPatientBehaviorsReductionByPatientId(this.props.patientId);
    }

    componentWillReceiveProps() {

        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    onSubmit(formData) {
        formData.behaviorsReductionArray = (formData.behaviorsReductionArray || []).map((behaviorsReductionObj) => {
            let behaviorsReductionData = this.props.masterPatientBehaviorsReduction.find(obj => obj.id === behaviorsReductionObj.behaviorsReductionId);
            return {
                ...behaviorsReductionObj,               
                behaviorName: behaviorsReductionData && behaviorsReductionData.value,
                patientEncounterId: this.state.patientEncounterId,
                sessionNoteId: this.state.sessionNoteId,
                ebsBehaviorsReductionId: this.state.ebsBehaviorsReductionId,
                isDeleted: false,                
            }
        });

        this.props.addBehaviorsReductionData(formData);
        this.setState({ open: false });
        this.props.closeDialog();
    };

    renderLoading() {
        return (
            <div>
                {this.props.loading ?
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                    : null}
            </div>
        );
    }

    addRow = () => { };
    removeRow = (i) => { };

    renderMembers = ({ fields }) => {
        this.removeRow = (i, e) => {
            fields.remove(i);
        };

        this.addRow = (e) => {
            fields.push({});
        };

        return (
            <div>
                {fields.map((behaviorsReductionObj, index) => {
                    // let restSelectors = (this.props.selectorbehaviorsReductionArray || []).filter((obj, pIndex) => pIndex !== index);
                    // let dropdownFilteredPatientbehaviorsReductions = _.differenceWith(this.props.masterPatientBehaviorsReduction, restSelectors, function(o1, o2) {
                    //     return o2['skillsAcquisitionTargetId'] == o1['id'];
                    // });
                    // let currentSelectorProgramId = this.props.selectorbehaviorsReductionArray && this.props.selectorbehaviorsReductionArray[index].behaviorsReductionId;
                    // let dropdownFilteredPatientbehaviorsReductions = (this.props.masterPatientBehaviorsReduction || []).filter(obj => obj.programId === currentSelectorProgramId);
                    return (<div className="row pdr-40 parent_div" key={index}>
                        <div className="col-sm-12 mt-35 require">
                            <Field
                                name={`${behaviorsReductionObj}.behaviorsReductionId`}
                                label="Behavior Name"
                                options={this.props.masterPatientBehaviorsReduction}
                                handleNewRequest={(input, selected) => input.onChange(selected.value)}
                                component={renderAutoCompleteSingleSelect}
                            />
                        </div>                        
                        <div className="col-sm-6 require">
                            <Field
                                name={`${behaviorsReductionObj}.data`}
                                type="text"
                                maxLength="5"
                                label="Data"
                                component={renderTextField}
                                normalize={isInteger}
                            />
                        </div>
                        <div className="col-sm-6">
                            <Field
                                name={`${behaviorsReductionObj}.comments`}
                                type="text"
                                maxLength="50"
                                label="Comment"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            {fields.length === index + 1 ?
                                <div>
                                    {fields.length > 1 ?
                                        <button className="removeitem"
                                            onClick={this.removeRow.bind(this, index)}
                                            title="Remove Behavior data"
                                            type="button">
                                            <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                                        </button>
                                        : ''}
                                    <button className="additem" title="Add Behavior data" onClick={(e) => this.addRow()} type="button">
                                        <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                                    </button>
                                </div>
                                :
                                <div>
                                    <button className="removeitem"
                                        onClick={this.removeRow.bind(this, index)}
                                        title="Remove Behavior data"
                                        type="button">
                                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                                    </button>
                                </div>
                            }
                        </div>

                    </div>);
                }
                )
                }
            </div>
        );
    };

    render() {
        const { handleSubmit } = this.props;
        const actions = [
            <CommonButton className="mr-15 grey_btn" label="Cancel" onTouchTap={this.handleClose} />,
            <CommonButton type="submit" primary={true} label="Save" onTouchTap={handleSubmit(this.onSubmit.bind(this))} />,
        ];
        return (
            <div>
                {this.state.open ?
                    <Dialog className="custom_modal"
                        title="Soap Data Entry"
                        modal={false}
                        actions={actions}
                        open={this.state.open}
                        autoScrollBodyContent={true}
                    >
                        {this.renderLoading()}
                        <div className="row">
                            <div className="col-sm-12">
                                <form className="readmin-form custom_form" noValidate>
                                   
                                    <FieldArray name="behaviorsReductionArray" component={this.renderMembers} />
                                </form>
                            </div>
                        </div>
                    </Dialog> : null}
            </div>
        );
    };
}
const selector = formValueSelector('AddBehaviorsReductionModalForm');
AddBehaviorsReductionModal = reduxForm({
    form: 'AddBehaviorsReductionModalForm',
    validate,
    enableReinitialize: true, // this is needed!!
})(AddBehaviorsReductionModal);

function mapStateToProps(state) {
    let masterPatientBehaviorsReduction = [],
    initialData = {
        behaviorsReductionArray: [{}],
    };
    if (state.soap.behaviorsReductionsData) {
        masterPatientBehaviorsReduction = state.soap.behaviorsReductionsData.data.PatientBehaviorsReduction || [];
    }

    return {
        loading: state.patient.loading || state.patient.loadingMasterData,
        masterPatientBehaviorsReduction: masterPatientBehaviorsReduction,        
        initialValues: initialData,
        selectorbehaviorsReductionArray: selector(state, "behaviorsReductionArray")
    };
};

export default connect(mapStateToProps, { getPatientBehaviorsReductionByPatientId })(AddBehaviorsReductionModal);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_EBS/addBehaviorsReductionModal.js